import type {
  BackendSavedDocumentItemTypeEnum,
  BackendSavedDocumentRatingEnum,
} from 'src/types/backend';

export const SAVED_DOCUMENT_RATING = {
  thumbsUp: 'thumbs_up',
  thumbsDown: 'thumbs_down',
} as const satisfies Record<string, BackendSavedDocumentRatingEnum>;
export type SavedDocumentRating = BackendSavedDocumentRatingEnum;

export const SAVED_DOCUMENT_ITEM_TYPE = {
  thread: 'thread',
  textRating: 'text_rating',
} as const satisfies Record<string, BackendSavedDocumentItemTypeEnum>;
export type SavedDocumentItemType = BackendSavedDocumentItemTypeEnum;
